<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title v-if="fieldName == 'acctNoSfx'">Account No. Suffix Helplist</v-toolbar-title>
        <v-toolbar-title v-else>Broker Account No. Suffix Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.acctNoSfx }}</td>
                  <td class="text-xs-left">{{ row.item.description }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      acctNoSfx: 'acctNoSfx',
      headers: [
        { text: 'Account No. Suffix', value: 'acctNoSfx' },
        { text: 'Description', value: 'description' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      labels: {
        acctNoSfx: 'Account No. Suffix',
        description: 'Description'
      },
      filters: {
        acctNoSfx: undefined,
        description: undefined
      },
      loading: false,
      selectedAcctNoSfx: undefined,
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  created() {
    if (this.prtFrom) {
      this.items = []
    } else {
      this.doInit()
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getCalcRateHelplist
      if (apiURI) {
        this.loading = true
        try {
          this.loading = true
          const expand = {
            fieldName: this.acctNoSfx,
            riType: ''
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((acctNoSfx) => {
                const convertList = {
                  acctNoSfx: acctNoSfx.acctNoSfx,
                  description: acctNoSfx.description
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(data) {
      const acctNoSfxObj = {
        fieldName: this.fieldName,
        acctNoSfx: data.acctNoSfx,
        description: data.description
      }
      this.$emit('selectAcctNoSfx', acctNoSfxObj)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.calcRate.menu
    }
  },
  props: {
    fieldName: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>

<style>
</style>
